export const getContainerFactoryStyles = () =>
  ({
    Container: {
      width: '100%',
      border: '1px solid #605E5C',
      padding: '10px',
      boxSizing: 'border-box',
      marginBottom: '12px',
    },
    Invisible: {
      display: 'none',
    },
    AddNewQuery: {
      '& .ms-Button--command': {
        padding: '0',
        '& i.ms-Button-icon': {
          marginLeft: '0',
        },
        '& div.ms-Button-textContainer': {
          color: 'rgb(0, 120, 212)',
        },
        '&:hover div.ms-Button-textContainer': {
          color: 'rgb(0, 69, 120)',
          textDecoration: 'underline',
        },
      },
    },
    BottomButtonContainer: {
      marginTop: '15px',
    },
  });
